import { Component, ElementRef, NgZone, OnInit, ViewChild,ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators, NgForm ,FormBuilder} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { MustMatch } from 'app/shared/directives/must-match.validator';
import { ToastrService } from 'ngx-toastr';
import { MapsAPILoader } from '@agm/core';
// import { google } from '@agm/core/services/google-maps-types';
export class User {
  public fname: string;
  public lname: string;
  public city: string;
}
@Component({
  selector: 'app-users-add',
  templateUrl: './users-add.component.html',
  styleUrls: ['./users-add.component.scss' , '../../../../../../assets/sass/libs/select.scss'],
  encapsulation: ViewEncapsulation.None
})


export class UsersAddComponent implements OnInit {
   @ViewChild('vform') validationForm: FormGroup;
   
   @ViewChild("search")
   public searchElementRef: ElementRef;
  roles=[]
  fileData:File;
  courseList=[];
  batchList=[];
  selectedValue:string[]=[];
  selectValue='';
  selectedRole='';
  selectedCourse='';
  selectedBatch='';
  user: User;
  model = new User();
  submitted = false;
  isAdmin:boolean=false
  isManager:boolean=false
  isStudent:boolean=false
  userFormSubmitted=false;
  userForm: FormGroup;
  studentFormSubmitted=false;
  studentForm: FormGroup;
  selectedCollege=null
  collegeList=[];
   courses=[]
   courseData:any
   currentUrl:any
   studentId:any
   userId:any
   usersList = [];
   selectedHuntingBy = null;
   selectedFarmingBy = null;
   selectedTeam=null;
  teamList = [];
   teamId = '631ad9b6ce5c666542591be9'
   badgeId= '631ada06ce5c666542591bf2'
   selectBadge:string[]=[]
   badgeList=[];
   storeData:any
   address: string;
   latitude: number;
   longitude: number;
   zoom: number;
  private geoCoder;
  constructor(private formBuilder: FormBuilder,
    public toastr: ToastrService,
    public apiService:ApiService,private route:Router,
    private mapsAPILoader: MapsAPILoader,
    private activatedroute:ActivatedRoute,
    private ngZone: NgZone,) {  this.currentUrl=this.activatedroute.snapshot.routeConfig.path
      console.log('==route>>>',this.activatedroute.snapshot.routeConfig.path)

  //    this.getRoles();
  //  this.getCourseList();
  //    this.getBatchList();   
  this.locationAutoComplete()
  }

  ngOnInit() { 
    this.getCourseList();
    this.getAllCollege();
    this.getTeamTagByCategory();
    this.getUsers();
    this.getBadegeTagByCategory();
    // --------------------Student Form-------------------------------------
    this.studentForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone : ['', [Validators.required,Validators.minLength(10),Validators.maxLength(10)]],
      dob: ['', Validators.required],
      sex: ['',Validators.required],
      address: ['', Validators.required],
      lat: ['',Validators.required],
      lng: ['', Validators.required],
      notes: ['', Validators.required],
      admin_notes: ['', Validators.required],
      badges: ['', Validators.required],
      hunting_by: ['', Validators.required],
      course_id: ['', Validators.required],
      farming_by: ['', Validators.required],
      team: ['', Validators.required],
      project_ids: ['', Validators.required],
      next_payment_date: ['', Validators.required],
      placementinfo: ['', Validators.required],
      overview: ['', Validators.required],
      college_id: ['', Validators.required],
      last_qualification: ['', Validators.required],
      bio: ['', Validators.required],
    })
    if(this.currentUrl == 'allUsers-list'){
      
    }
    else if( this.currentUrl == 'students-list'){
      
    }
    // this.getRoles()
  
  
    this.userForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required,Validators.minLength(4)]],
      confirmPassword: ['', Validators.required],
      phone : ['', [Validators.required,Validators.minLength(10),Validators.maxLength(10)]],
      roles: ['', Validators.required],
      linkedIn: ['', Validators.required],
      dob: ['', Validators.required],
      sex: ['',Validators.required],
      address: ['', Validators.required],
      lat: ['',Validators.required],
      lng: ['', Validators.required],
      notes: ['', Validators.required],
      admin_notes: ['', Validators.required],
      image:['', Validators.required]
// --------- end -----------------------------


    }, {
       validator: MustMatch('password', 'confirmPassword')
    })

   


  }
  get rf() {
    return this.userForm.controls;
  }

 
 
//   getRoles(){
//     this.apiService.getRoles().subscribe((res:any)=>{
//       console.log('roles list res',res)
//       this.roles=res.data
//     })
//   }
//   getRoleId(event:any){
//     console.log('selected role ',this.selectedRole)
//     var role =this.roles.filter((role)=>role._id === this.selectedRole)

//     if(this.selectedRole && role[0].type === 'admin'){
//       this.isAdmin=true
//     console.log("role idd",this.selectedRole ,'role',role[0].type)
//     }
//     else if(this.selectedRole && role[0].type === 'manager'){
//       this.isManager=true
//     console.log("role idd",this.selectedRole ,'role',role[0].type)
//     }
//     else if(this.selectedRole && role[0].type ==='student'){
//       this.isStudent=true
//     console.log("role idd",this.selectedRole,'role',role[0].type)
//   }  
// }

getAllCollege(){
  this.apiService.getBusinessList(1,100).subscribe((res:any)=>{
    console.log('college list ==',res)
    this.collegeList=res.data.items
  })
}
getCollegeId(event:any){
  console.log('selected college id',this.selectedCollege)
}

getCourseList(){
  this.apiService.getCourseList(1,100).subscribe((res:any)=>{
    console.log(res)
    this.courseList=res.data.items 
  })
 }
 getCourseId(event: any) {
  console.log('course', this.selectedCourse)
  
}
getTeamTagByCategory() {
  this.apiService.getTagByTagCatgoryId(this.teamId).subscribe((res: any) => {
    console.log('team List', res)
    this.teamList = res.data
  })
}
getTeamId(event:any){
  console.log('team',this.selectedTeam)
}
getUsers() {
  this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
    this.usersList = res.items
    console.log('empl',res.items)
  })
}
getHuntId(event: any) {
  console.log('selectedHuntingBy', this.selectedHuntingBy)
}
getFarmId(event: any) {
  console.log('selectedFarmingBy', this.selectedFarmingBy)
}
getBadegeTagByCategory() {
  this.apiService.getTagByTagCatgoryId(this.badgeId).subscribe((res: any) => {
    console.log('badge List', res)
    this.badgeList = res.data
  })
}
getBadgeId(event:any){
  console.log('selectBadge',this.selectBadge)
}

 change(event): void{
  this.selectValue=event.target.value
  console.log('sex',this.selectValue)
 }
  onSelectFile(event:any){
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.fileData = event.target.files[0];
      console.log('event',this.fileData)
      reader.readAsDataURL(event.target.files[0]);
    }
  }


submitForm(){
  let formData=new FormData();
  // for (let item of this.selectedValue){
  //   console.log('course', item)
  //   formData.append('course[]', item)
  // }
  // for (let item of this.selectedBatch){
  //   console.log(' batch==>>',item)
  //   formData.append('batch[]',item)
  // }
  formData.append('name', this.userForm.controls.name.value),
  formData.append('roles', this.userForm.controls.roles.value),
  formData.append('dob', this.userForm.controls.dob.value),
  formData.append('email', this.userForm.controls.email.value),
  formData.append('linkedIn', this.userForm.controls.linkedIn.value),
  formData.append('address',JSON.stringify(this.address))
  formData.append('lat',JSON.stringify(this.latitude)),
  formData.append('lng', JSON.stringify(this.longitude)),
  formData.append('notes', this.userForm.controls.notes.value),
  formData.append('admin_notes', this.userForm.controls.admin_notes.value),

  formData.append('sex', this.selectValue),
  // formData.append('college', this.userForm.controls.college.value),
  formData.append('phone', this.userForm.controls.phone.value),
  // formData.append('lastQualification', this.userForm.controls.lastQualification.value),
  formData.append('password', this.userForm.controls.password.value),
  formData.append('image', this.fileData )
 
  // this.userFormSubmitted = true;
  if(this.userForm.controls.email.valid && this.userForm.controls.password.value === this.userForm.controls.confirmPassword.value
    && this.userForm.controls.phone.valid){
    console.log('form value',this.userForm.value)
    this.apiService.addUser(formData,).subscribe((res:any)=>{
      if(res.isSuccess === true){
        console.log('add res',res)
        this.toastr.success(res.message)
      this.route.navigate(['/allUsers-list']) 
      }   
      else{this.toastr.error(res.error)}
    })
  }
  else{
    this.toastr.error('please fill required fields!')
  }
 
}

back(){
  this.route.navigate(['/allUsers-list'])    
}
locationAutoComplete() {
  this.mapsAPILoader.load().then(() => {
    this.geoCoder = new google.maps.Geocoder;

    let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef?.nativeElement);
    autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        let place: google.maps.places.PlaceResult = autocomplete.getPlace();
        this.address = place.formatted_address;
        console.log('address', this.address)
        // verify result
        if (place.geometry === undefined || place.geometry === null) {
          return;
        }

        // set latitude, longitude and zoom
        this.latitude = place.geometry.location.lat();
        this.longitude = place.geometry.location.lng();
        this.zoom = 12;
        console.log("lat lng",this.latitude,this.longitude)
      });
    });
  });
}
submitStudentForm(){
 // for (let item of this.selectedCourse){
  //   console.log('course', item)
  //   formData.append('course[]', item)
  // }
  // for (let item of this.selectedBatch){
  //   console.log(' batch==>>',item)
  //   formData.append('batch[]',item)
  // }

  let body = {
    name: this.studentForm.value.name,
    badges: this.selectBadge,
    email: this.studentForm.value.email,
    dob: this.studentForm.value.dob,
    sex: this.selectValue,
    phone: this.studentForm.value.phone,
    bio: this.studentForm.value.bio,
    hunting_by: this.selectedHuntingBy,
    course_id: this.selectedCourse,
    farming_by: this.selectedFarmingBy,
    team: this.selectedTeam,
    project_ids: this.studentForm.value.project_ids,
    next_payment_date: this.studentForm.value.next_payment_date,
    placementinfo: this.studentForm.value.placementinfo,
    overview: this.studentForm.value.overview,
    college_id: this.selectedCollege,
    // formData.append('lat',JSON.stringify(this.latitude)),
  // formData.append('lng', JSON.stringify(this.longitude)),
    lat: this.latitude,
    lng:this.longitude,
    // location:this.address,
    address:this.address,
    last_qualification: this.studentForm.value.last_qualification,
    admin_notes: this.studentForm.value.admin_notes,
    notes: this.studentForm.value.notes,
  }
  this.apiService. addStudent(body).subscribe((res:any)=>
  {
    if(res.isSuccess === true){
    console.log('Created Successfully',res)
    this.toastr.success('Student add successfully',res.message)
    this.route.navigate(['/students-list']) 
    }   
    else{this.toastr.error(res.error)}
  })
}



}